export default __webpack_public_path__ + "static/media/personal_login.5c178118.svg";